// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"656":"profiler","952":"recorder"}[chunkId] + "." + {"656":"166293f8","952":"1013c607"}[chunkId] + ".chunk.js";
};